import React, { useState } from 'react';
import axios from 'axios';
import './Home.css';
import { API_URL } from '../config/data';

const Home = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Очищаем ошибку при изменении поля
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    
    // Очищаем сообщение об успехе
    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value;
    
    // Удаляем все нецифровые символы
    const digitsOnly = value.replace(/\D/g, '');
    
    // Ограничиваем длину для российского номера (10 цифр)
    const limitedDigits = digitsOnly.slice(0, 10);
    
    // Применяем российскую маску: 999 999 99 99
    if (limitedDigits.length > 0) {
      value = limitedDigits.replace(/(\d{3})(\d{0,3})(\d{0,2})(\d{0,2})/, (match, p1, p2, p3, p4) => {
        let result = p1;
        if (p2) result += ` ${p2}`;
        if (p3) result += ` ${p3}`;
        if (p4) result += ` ${p4}`;
        return result;
      });
    } else {
      value = '';
    }
    
    setFormData(prev => ({
      ...prev,
      phone: value
    }));
    
    if (errors.phone) {
      setErrors(prev => ({
        ...prev,
        phone: ''
      }));
    }
    
    if (successMessage) {
      setSuccessMessage('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Введите ФИО';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Введите номер телефона';
    } else {
      const phoneDigits = formData.phone.replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        newErrors.phone = 'Введите полный номер телефона';
      }
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Введите email';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Введите корректный email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCallback = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setErrors({});
    setSuccessMessage('');

    try {
      const response = await axios.post(`${API_URL}/api/contact/callback`, {
        fullName: formData.fullName.trim(),
        phone: formData.phone.trim(),
        email: formData.email.trim()
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 200) {
        setSuccessMessage('Заявка успешно отправлена! Мы свяжемся с вами в ближайшее время.');
        setFormData({
          fullName: '',
          phone: '',
          email: ''
        });
      }
    } catch (error) {
      console.error('Ошибка при отправке формы:', error);
      
      if (error.response) {
        const errorData = error.response.data;
        if (errorData.message) {
          setErrors({ general: errorData.message });
        } else {
          setErrors({ general: 'Ошибка при отправке заявки. Попробуйте позже.' });
        }
      } else if (error.request) {
        setErrors({ general: 'Ошибка сети. Проверьте подключение к интернету.' });
      } else {
        setErrors({ general: 'Произошла непредвиденная ошибка' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleTelegram = () => {
    window.open('https://t.me/ProTop01123', '_blank');
  };

  return (
    <div className="wrapper">
      <header data-fls-header="" data-fls-header-scroll="" className="header">
        <div className="header__container header__container--full">
          <div className="header__body">
            <a href="/" className="header__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
            <div className="header__actions">
              <a href="/login" data-fls-button="" className="header__button button button--fw button--border">Вход</a>
              <a href="/signup" data-fls-button="" className="header__button button button--fw">Регистрация</a>
            </div>
          </div>
        </div>
      </header>
      <main className="page page--landing">
        <section className="hero">
          <div className="hero__container hero__container--full">
            <div className="hero__body">
              <h1 className="hero__title">
                Инвестиции в счета
                <br />
                профессиональных
                <br />
                управляющих
              </h1>
              <div className="hero__text">
                <p>
                  Уровень доходности
                  <span> 30% годовых </span>
                  привлекает инвесторов,
                  <br />
                  стремящихся к приумножению средств.
                </p>
              </div>
              <a href="/signup" data-fls-button="" className="hero__button button">Инвестировать</a>
            </div>
          </div>
        </section>
        <section className="advant">
          <div className="advant__container advant__container--full">
            <div className="advant__body">
              <h2 className="advant__title">5 преимуществ инвестирования в ПАММ-счета</h2>
              <div className="advant__items">
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/01.svg" alt="Icon" />
                    Сверхдоходность
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>
                      Трёхзначная потенциальная доходность при инвестициях в торговлю опытных трейдеров
                    </p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/02.svg" alt="Icon" />
                    Гибкие сроки
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>
                      Различные по срокам условия инвестирования средств от одного месяца до года и больше
                    </p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/03.svg" alt="Icon" />
                    Быстрота
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>Экономьте время на обучении, изучении аналитики и самостоятельной торговле</p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/04.svg" alt="Icon" />
                    Прозрачность
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>Следите за графиком торговли управляющего и проведенными операциями</p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/05.svg" alt="Icon" />
                    Профессионализм
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>Трейдинг осуществляется под полным контролем профессиональных управляющих</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="scheme">
          <div className="scheme__container">
            <div className="scheme__body">
              <div className="scheme__level scheme__level--center">
                <div className="scheme__element">
                  <span>Управляющий</span>
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/01.svg" alt="Icon" />
                  </div>
                  <span>Торговая платформа</span>
                </div>
              </div>
              <div className="scheme__level scheme__level--end">
                <picture className="scheme__arrow">
                  <source media="(max-width: 991.98px)" srcSet="./assets/img/scheme/arrow/min.svg" />
                  <img src="./assets/img/scheme/arrow/big.svg" alt="Arrow" />
                </picture>
                <div className="scheme__element">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/02.svg" alt="Icon" />
                  </div>
                  <span>
                    Доверительное управление
                    <br />
                    торговлей
                  </span>
                </div>
                <picture className="scheme__arrow scheme__arrow--scale">
                  <source media="(max-width: 991.98px)" srcSet="./assets/img/scheme/arrow/min.svg" />
                  <img src="./assets/img/scheme/arrow/big.svg" alt="Arrow" />
                </picture>
              </div>
              <div className="scheme__level scheme__level--arrow">
                <img src="./assets/img/scheme/arrow/str.svg" alt="Arrow" />
              </div>
              <div className="scheme__level">
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/03.svg" alt="Icon" />
                  </div>
                  <span>Инвестиционный счет</span>
                </div>
                <span className="scheme__span">Инвестиционный счет</span>
                <div className="scheme__element scheme__element--center">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/03.svg" alt="Icon" />
                  </div>
                  <span>Инвестиционный счет</span>
                </div>
                <span className="scheme__span">Инвестиционный счет</span>
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/03.svg" alt="Icon" />
                  </div>
                  <span>Инвестиционный счет</span>
                </div>
              </div>
              <div className="scheme__level">
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/04.svg" alt="Icon" />
                  </div>
                </div>
                <div className="scheme__element scheme__element--center">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/04.svg" alt="Icon" />
                  </div>
                </div>
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/04.svg" alt="Icon" />
                  </div>
                </div>
              </div>
              <div className="scheme__level">
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/05.svg" alt="Icon" />
                  </div>
                  <span>Инвестор</span>
                </div>
                <span className="scheme__span">Инвестор</span>
                <div className="scheme__element scheme__element--center">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/05.svg" alt="Icon" />
                  </div>
                  <span>Инвестор</span>
                </div>
                <span className="scheme__span">Инвестор</span>
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/05.svg" alt="Icon" />
                  </div>
                  <span>Инвестор</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="invest">
          <div className="invest__container invest__container--full">
            <div className="invest__body">
              <h3 className="invest__title invest__title--title-25">Вклады в инвестиционные ПАММ счета</h3>
              <div className="invest__content">
                <h4 className="invest__subtitle invest__subtitle--title-18">Сервис ПАММ счетов –</h4>
                <div className="invest__text">
                  <p>Это система процентного распределения прибыли между управляющим и инвестором</p>
                  <p>
                    Другими словами, ПАММ – счет где, управляющий имеет возможность использовать в торговле привлеченные средства инвесторов.
                  </p>
                  <p>
                    Заключается оферта – это договор, в котором регламентируются отношения между инвестором и управляющим. Прибыль получаемая в результате торговой деятельности управляющего, распределяется между инвесторами пропорционально вложенной сумме.
                  </p>
                </div>
                <a href="#" data-fls-button="" className="invest__button button">Попробовать</a>
              </div>
            </div>
          </div>
        </section>
        <section className="protect">
          <div className="protect__container protect__container--full">
            <div className="protect__body">
              <div className="protect__head">
                <h3 className="protect__title protect__title--title-25">Защита инвестиций</h3>
                <div className="protect__text protect__text--text">
                  <p>
                    Дилер биржевого рынка выступает в роли
                    <span>независимого гаранта</span>
                    выполнения обязательств как управляющего, так и инвестора. Отсюда вытекают следующие преимущества:
                  </p>
                </div>
              </div>
              <div className="protect__items items-protect">
                <div data-fls-shadow="" className="items-protect__item items-protect__item--text">
                  <p>Управляющий не может взять и уйти с деньгами инвесторов.</p>
                </div>
                <div data-fls-shadow="" className="items-protect__item items-protect__item--text">
                  <p>
                    Ваши средства и прибыль находятся на общем ПАММ-счёте, и только вы можете распоряжаться ими, так как они не передаются управляющему.
                  </p>
                </div>
                <div data-fls-shadow="" className="items-protect__item items-protect__item--text">
                  <p>
                    При консервативной торговле управляющий рискует только прибылью, а не капиталом инвесторов.
                  </p>
                </div>
              </div>
              <div className="protect__text protect__text--reverse protect__text--text">
                <p>
                  <span>Вывод прибыли.</span>
                  ПАММ-сервис позволяет настроить автоматический вывод прибыли по окончанию торгового интервала, что обеспечит Вам постоянный поток прибыли и ее сохранение на своем отдельном торговом счете.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="contact">
          <div className="contact__container contact__container--full">
            <div className="contact__body">
              <h3 className="contact__title contact__title--title-25">Свяжитесь с нами</h3>
              <form className="contact__form" onSubmit={handleCallback}>
                {errors.general && (
                  <div className="contact__error-general">
                    {errors.general}
                  </div>
                )}
                {successMessage && (
                  <div className="contact__success">
                    {successMessage}
                  </div>
                )}
                <div className="contact__field">
                  <input
                    required
                    data-fls-input=""
                    autoComplete="off"
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="ФИО"
                    className={`input ${errors.fullName ? '--form-error' : ''}`}
                  />
                  {errors.fullName && <div className="contact__error-text">{errors.fullName}</div>}
                </div>
                <div className="contact__field">
                  <div className="contact__phone-container">
                    <div className="contact__phone-flag">
                      <img src="/assets/img/ru.svg" alt="Flag" />
                    </div>
                    <div className="contact__phone-code">
                      <span className="contact__country-code">+7</span>
                    </div>
                    <input
                      required
                      data-fls-input=""
                      autoComplete="off"
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handlePhoneChange}
                      placeholder="999 999 99 99"
                      className={`contact__phone-input ${errors.phone ? '--form-error' : ''}`}
                    />
                  </div>
                  {errors.phone && <div className="contact__error-text">{errors.phone}</div>}
                </div>
                <div className="contact__field">
                  <input
                    required
                    data-fls-input=""
                    autoComplete="off"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    className={`input ${errors.email ? '--form-error' : ''}`}
                  />
                  {errors.email && <div className="contact__error-text">{errors.email}</div>}
                </div>
                <div className="contact__buttons">
                  <button
                    type="submit"
                    data-fls-button=""
                    className="contact__button button button--fw"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Отправляем...' : 'Заказать звонок'}
                  </button>
                  <button
                    type="button"
                    data-fls-button=""
                    className="contact__button contact__button--telegram button button--fw button--border"
                    onClick={handleTelegram}
                  >
                    Связаться в телеграм
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
      <footer data-fls-footer="" className="footer">
        <div className="footer__container footer__container--full">
          <div className="footer__body">
            <a href="/" className="footer__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
            <div className="footer__actions">
              <a href="/login" data-fls-button="" className="footer__button button button--fw button--border-white">Вход</a>
              <a href="#" data-fls-button="" className="footer__button button button--fw">Регистрация</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;